import { render, staticRenderFns } from "./ManualBankAccountForm.vue?vue&type=template&id=2c1b10c4&scoped=true"
import script from "./ManualBankAccountForm.vue?vue&type=script&lang=js"
export * from "./ManualBankAccountForm.vue?vue&type=script&lang=js"
import style0 from "./ManualBankAccountForm.vue?vue&type=style&index=0&id=2c1b10c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1b10c4",
  null
  
)

export default component.exports